
import React from "react";
import { useNavigate } from "react-router-dom";

interface PublicAgentErrorProps {
  error: string;
  isEmbedded?: boolean;
}

export const PublicAgentError: React.FC<PublicAgentErrorProps> = ({ 
  error, 
  isEmbedded = false 
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="max-w-md mx-auto text-center space-y-4">
        <h1 className="text-2xl font-bold">Agent Not Found</h1>
        <p className="text-muted-foreground">
          {error || "The agent you're looking for doesn't exist or has been deactivated."}
        </p>
        {!isEmbedded && (
          <button 
            onClick={() => navigate("/")}
            className="bg-[#060520] text-white px-4 py-2 rounded hover:bg-[#060520]/90"
          >
            Go Home
          </button>
        )}
      </div>
    </div>
  );
};
